<ln-ln-pages-armor>
  <section body>
    <!--      volver button for mobile -->
<!-- class="mx-[36px] block sm:hidden"   -->
    <section [ngClass]="[currentScreenSize()=== 'SM' ? 'block' : 'hidden', 'mx-[36px]']">
      <button (click)="navigateBack()" class="mt-[22px] mb-[14px]">
        <ln-ln-arrow-back-svg-icon [class]="'h-[24px] w-[p4px]'"></ln-ln-arrow-back-svg-icon>
      </button>
    </section>
    <div class="border-t-opacity-10 border-t-[1.8px] border-t-beige bg-blanco bg-opacity-10 ">
      <div class="max-w-[1440px] mx-auto flex flex-col justify-center">
      <div class="mx-[36px] sm:mx-[120px]">
        <!-- top components -->
        <!--      volver button-->
<!--        class="hidden sm:block"-->
        <section [ngClass]="[currentScreenSize() === 'SM' || currentScreenSize() === 'MD' ? 'hidden' : 'block']">
          <button (click)="navigateBack()" class="mt-[15px] mb-[34px] flex items-center transition duration-100 hover:scale-110">
            <ln-ln-arrow-back-svg-icon [class]="'h-[24px] w-[p4px]'"></ln-ln-arrow-back-svg-icon>
            <span class="font-['Roboto'] text-base font-normal text-cafe ml-[6px]">{{'buttons.goBack' | transloco}}</span>
          </button>
        </section>
        @if(productDetail() !== null) {
<!--          class="mx-auto grid grid-cols-1 items-start gap-6 sm:mt-0 md:gap-[30px] md:grid-cols-[100px_600px_1fr] pt-[21px] sm:pt-[0px]"-->
          <section [ngClass]="[currentScreenSize() === 'LG' ? 'grid-cols-[100px_600px_1fr] pt-[0px] mt-0 gap-[30px]' : 'grid-cols-1 gap-6', 'mx-auto grid mt-0 pt-[21px]']">
            <!-- Image Gallery thumbnails -->
<!--          class="order-2 md:order-1"-->
            <ln-product-info-thumbnails
              [selectedImage]="selectedImageIndex"
              [activosDigitales]="productDetail()!.productos[selectedVariant()].activosDigitales"
              (selectedImageChange)="ChangeSelectedImage($event)"
              [ngClass]="[currentScreenSize() === 'LG' ? 'order-1' : 'order-2']"></ln-product-info-thumbnails>
            <!-- Main Image -->
<!--          class="order-1 flex-1 md:order-2"-->
            <ln-product-info-main-image
              [selectedImageIndex]="selectedImageIndex"
              [activosDigitales]="productDetail()!.productos[selectedVariant()].activosDigitales"
              (selectedImageChange)="ChangeSelectedImage($event)"
              [ngClass]="[currentScreenSize() === 'LG' ? 'order-2' : 'order-1', 'flex-1']"></ln-product-info-main-image>
            <!-- Product Info -->
              <ln-product-info-detail class="order-3" [productDetails]="productDetail()!" [selectedVariant]="selectedVariant"></ln-product-info-detail>
          </section>

          <section class="mt-[30px] mb-4 border-b border-t border-b-gris border-t-gris py-4">
            <ln-acordeon-paragraph [tittle]="'labels.description' | transloco">
              <div body class="font-['Roboto'] text-cafe">
                {{productDetail()!.traducciones[0].descripcion}}
              </div>
            </ln-acordeon-paragraph>
          </section>

          <section class="border-b border-b-gris pb-4">
            <ln-acordeon-paragraph [tittle]="'labels.characteristics' | transloco">
              <div body class="text-base font-normal font-['Roboto'] text-cafe">
                    {{productDetail()!.traducciones[0].caracteristicas}}
              </div>
            </ln-acordeon-paragraph>
          </section>
        }

      </div>
      <div >
        <!--        carrusel de productos -->
        <section class="px-[6.5px] sm:px-[85.5px]">
          <ln-other-products-of-ln-home [artisanID]="artisanID"></ln-other-products-of-ln-home>
        </section>
        <div class="sm:mx-[85.5px] border-b border-b-gris">

        </div>
      </div>
      </div>
    </div>
  </section>
</ln-ln-pages-armor>
